export default __webpack_public_path__ + "static/media/g3n3zis.f444d992.svg";